import { IconGlobe2Outline18 as Globe } from "nucleo-ui-outline-18"

import { Button, Input } from "@productlane/ui"

import { useZeroWorkspace } from "@/lib/zero"
import { useImportPortalId } from "../../import-portal"
import { useSiteImport } from "../../use-site-import"

export function SiteImportField() {
	const portalInstanceId = useImportPortalId()
	const siteImport = useSiteImport({ portalInstanceId })
	const workspace = useZeroWorkspace()
	const isHelpCenterPublic = !!workspace?.helpCenterPublic

	return (
		<div>
			<header className="space-y-1 text-sm">
				<div className="text-base font-medium">Import from a URL</div>
				<div className="mb-6 text-secondary">
					Read an existing help center and turn every page into an article.{" "}
					{isHelpCenterPublic
						? "They arrive as drafts, so you pick what goes live."
						: "They arrive live, ready for the day you turn your help center on."}
				</div>
			</header>

			<div className="mt-4 flex items-start gap-2">
				<Input
					name="help-center-url"
					className="flex-1"
					icon={Globe}
					inputClassName="h-8 rounded-lg"
					placeholder="help.acme.com"
					value={siteImport.url}
					errorMessage={siteImport.error}
					onChange={(event) => siteImport.change(event.target.value)}
					onKeyDown={(event) => {
						if (event.key !== "Enter") return
						event.preventDefault()
						void siteImport.run()
					}}
				/>
				<Button
					className="h-8 flex-none"
					isLoading={siteImport.isLoading}
					onClick={() => void siteImport.run()}
				>
					Import
				</Button>
			</div>
		</div>
	)
}
